export const maximumAttachmentSize = 10; // MiB
export const defaultLinkStyle = "wikilink";
